export const navigationMenu = {
  desktopMenu: 'desktop-navigation-menu-bar',
  mobileMenu: 'mobile-navigation-menu-bar',
  menuItem: 'navigation-menu-item',
  menuItemDivider: 'menu-item-divider',
};
